// test732
(732 && 0);
